import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownSection, DropdownTrigger } from '@heroui/react';
import { EllipsisVertical } from 'lucide-react';
import React, { FC } from 'react';

import { Action, TableItem } from '../../../../types';
import { Flex } from '../../../Flex';

interface TableActionsProps {
    actions?: Action[];
    item: TableItem;
}
export const TableActions: FC<TableActionsProps> = ({ actions, item }) => {
  if (!actions) {
    return null;
  }

  return (
    <Flex justifyContent="center">
      <Dropdown
        classNames={{
          base: 'before:bg-default-200', // change arrow background
          content: 'border border-default-200 bg-gradient-to-br from-white to-default-200 dark:from-default-50 dark:to-black',
        }}
      >
        <DropdownTrigger>
          <Button isIconOnly size="sm" variant="light">
            <EllipsisVertical size={14} color="#676767" />
          </Button>
        </DropdownTrigger>
        <DropdownMenu variant="faded">
          {actions?.map((action) => (
            <DropdownSection key={action.label} showDivider={action.hasDivider} title={action.sectionName}>
              <DropdownItem
                key={action.label}
                color={action.color}
                className={action.color === 'danger' ? 'text-danger' : ''}
                startContent={action.icon || null}
                onPress={() => action.onClick?.(item)}
              >
                <p className="text-sm">{action.label}</p>
              </DropdownItem>
            </DropdownSection>
          ))}

        </DropdownMenu>
      </Dropdown>
    </Flex>

  );
};
